import styled from 'styled-components'

const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 24px;
`;

export default Wrapper